import * as React from "react";

interface ISayLogoTextProps {
  fill?: string;
}

const SayLogoText: React.SFC<ISayLogoTextProps> = ({ fill }) => {
  return (
    <svg
      width="82"
      height="20"
      viewBox="0 0 82 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill={"none"} fillRule="evenodd">
        <path
          d="M95.6711982,74.7126234 L105.203664,74.7126234 L100.437431,67.3228532 L95.6711982,74.7126234 Z M103.590743,63.2433074 L115.959462,82.1016333 L115.959462,82.5530653 L110.226168,82.5530653 L107.840979,78.8370981 L93.0304289,78.8370981 L90.6480033,82.5530653 L84.9078013,82.5530653 L84.9078013,82.1079234 L97.2799744,63.2433074 L103.590743,63.2433074 Z M70.1117572,70.4962172 C64.915182,70.4962172 63.1005598,70.4270958 63.1005598,68.9064247 C63.1005598,67.567543 64.8792626,67.1369166 70.6367335,67.1369166 C76.6891583,67.1369166 81.5507157,68.7467543 81.5507157,68.7467543 L81.9257975,68.6223357 L81.9257975,64.5497021 C81.9257975,64.5497021 77.4545186,63 70.5331198,63 C63.9695338,63 58,64.0001868 58,69.5962564 C58,75.1142188 62.3193121,75.1874875 71.7322763,75.1874875 C76.4591358,75.1874875 78.690976,75.1674423 78.690976,76.8132231 C78.690976,78.3269821 75.9928739,78.7652118 70.32382,78.7652118 C62.7731403,78.7652118 58.4704064,76.8360332 58.4704064,76.8360332 L58.1036138,77.0184446 L58.1036138,81.270863 L58.2597251,81.3199392 C61.4959281,82.3415537 65.8553041,82.9069669 70.5331198,82.9069669 C79.8238198,82.9069669 83.7915358,81.4989637 83.7915358,76.3611691 C83.7915358,71.1729158 80.1512392,70.4962172 70.1117572,70.4962172 Z M139.957098,63.2419249 L139.957098,63.6988175 L139.888023,63.7762335 L128.13546,76.4786755 L128.13546,82.5544477 L122.747545,82.5544477 L122.747545,76.4786755 L110.923143,63.6988175 L110.923143,63.2419249 L116.958299,63.2419249 L116.994909,63.2820154 L125.438739,72.6237743 L133.91918,63.2419249 L139.957098,63.2419249 Z"
          transform="translate(-58 -63)"
          fill={fill ? fill : "#2D2D2D"}
        />
      </g>
    </svg>
  );
};

export default SayLogoText;



// WEBPACK FOOTER //
// ./src/components/SayLogoText/SayLogoText.tsx